import { LocalizedText, useDialogAction } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TooltippedSpan } from '@mews-commander/ui';
import { PortfolioVoucherOverview } from '@mews-commander/data-access';
import { IconName, TableBulkActionButton } from '@optimus-web/core';
import { EDIT_VOUCHER_STARTING_POINT } from '../../../../utilities/userFlowTestIds';
import { EditVoucherContainer } from './EditVoucherContainer';

interface Props {
    selectedRows: Array<PortfolioVoucherOverview>;
    areNoRowsSelected: boolean;
    currentPrimaryPropertyCount: number;
    onSuccess: () => void;
}

export const VoucherEditWrapper = ({
    selectedRows,
    areNoRowsSelected,
    currentPrimaryPropertyCount,
    onSuccess,
}: Props) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());
    const vouchersHaveDifferentKeys = selectedRows.some((voucher) => voucher.key !== selectedRows[0].key);

    const isEditDisabled = areNoRowsSelected || vouchersHaveDifferentKeys;

    const onEditSuccess = async () => {
        onSuccess();

        await handlers.handleConfirm();
    };

    return (
        <>
            <TooltippedSpan
                tooltip={isEditDisabled && <LocalizedText textKey={TextKey.SelectVouchersWithSameKeyTooltipHint} />}
            >
                <TableBulkActionButton
                    disabled={isEditDisabled}
                    icon={IconName.Edit}
                    onClick={handlers.handleOpen}
                    data-test-id={EDIT_VOUCHER_STARTING_POINT}
                >
                    <LocalizedText textKey={TextKey.Edit} />
                </TableBulkActionButton>
            </TooltippedSpan>

            <EditVoucherContainer
                states={states}
                handlers={handlers}
                selectedVouchers={selectedRows}
                selectedVouchersCount={currentPrimaryPropertyCount}
                onSuccess={onEditSuccess}
            />
        </>
    );
};
